import { useTranslation } from 'react-i18next'
import PageModal from '../../common/PageModal'
import SimpleButton from '../../common/SimpleButton'
import ToggleSwitch from '../../common/ToggleSwitch'
import { firmwareUploadWritePermission } from '../../../utils/permissionValidation'
import { getFileIcon } from '../../../utils/functions'
import { languagesShort } from '../../../utils/languages'
import '../uploads.scss'

const ViewDocumentFileModal = (props) => {
  const { t } = useTranslation()
  const { selectedFile, handleEditFile, closeModal } = props
  const documentFileStatuses = ['inactive', 'active']

  const documentFileHeaderContent = () => {
    return (
      <div className="status-wrapper">
        <div className="label">{t('status')}</div>
        <ToggleSwitch checked={selectedFile.isActive} isDisabled={true} />
        <div className="status">{t(documentFileStatuses[Number(selectedFile.isActive)])}</div>
      </div>
    )
  }

  const documentFileFooterContent = () => {
    return (
      <>
        <SimpleButton className="cancel-button" onClick={closeModal}>
          {t('close')}
        </SimpleButton>
        <SimpleButton className="action-button" onClick={handleEditFile} requiredPermission={firmwareUploadWritePermission}>
          {t('edit')}
        </SimpleButton>
      </>
    )
  }

  return (
    <>
      <PageModal
        toggle
        onToggle={closeModal}
        className="uploads-modal"
        title={t('details')}
        headerContent={documentFileHeaderContent()}
        footerContent={documentFileFooterContent()}
      >
        <div className="uploads-modal-content">
          <div className="section-title">{t('general_information').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('file_name')}</p>
              <div className="value">
                {getFileIcon(selectedFile.fileName)}
                {selectedFile.fileName}
              </div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('firmware_context.firmware_type')}</p>
              <div className="value">{selectedFile.firmwareType}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('total_downloads')}</p>
              <div className="value">{selectedFile.totalDownloads || 0}</div>
            </div>
          </div>
          <div className="separator" />
          <div className="section-title">{t('settings').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('file_title')}</p>
              <div className="value">{selectedFile.fileTitle}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('language')}</p>
              <div className="value">{`${t(languagesShort[selectedFile.languageCode?.toLowerCase()] || selectedFile.languageCode)} (${selectedFile.languageCode})`}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('document_context.revision_number')}</p>
              <div className="value">{selectedFile.revision}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('monitoring.models')}</p>
              <div className="ordered-list-wrapper">
                <div className="columns-wrapper small-columns">
                  {selectedFile.models?.map((model, index) => (
                    <div className="value" key={index}>
                      {model}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageModal>
    </>
  )
}

export default ViewDocumentFileModal
